<span *ngIf="frequency=='d'" class="mx-2"
      mdbTooltip="Daily historical data">
  <mdb-badge color="primary-color">D</mdb-badge>
</span>
<span *ngIf="frequency=='w'" class="mx-2"
      mdbTooltip="Weekly historical data">
  <mdb-badge color="success-color">W</mdb-badge>
</span>
<span *ngIf="frequency=='m'" class="mx-2"
      mdbTooltip="Monthly historical data">
  <mdb-badge color="warning-color">M</mdb-badge>
</span>
<span *ngIf="frequency=='q'" class="mx-2"
      mdbTooltip="Quarterly historical data">
  <mdb-badge color="danger-color">Q</mdb-badge>
</span>
<span *ngIf="frequency=='y'" class="mx-2"
      mdbTooltip="Yearly historical data">
  <mdb-badge color="secondary-color">Y</mdb-badge>
</span>
